import {
  PatrolIcon360,
  PatrolIconExitFullscreen,
  PatrolIconFlat,
  PatrolIconFullscreen,
  PatrolIconPipPopupHidden,
  PatrolIconPipPopupVisible,
  PatrolIconSwitchCamera,
} from "./PatrolPreviewToolbarIcons.jsx";
import "./patrolLivePreviewToolbar.css";

/**
 * Live dual-camera toolbar (wankhede-360 preview controls).
 * Renders in Patrol Video Viewer header, left of Settings.
 */
export function PatrolLivePreviewToolbar({
  showView360Toggle = false,
  viewModeFlat = false,
  onToggleView360,
  showStreamTransportToggle = false,
  activeStreamTransport = "webrtc",
  mainStreamKind = "360",
  onToggleStreamTransport,
  showLensSwap = false,
  onToggleLens,
  showFullscreen = true,
  isFullscreen = false,
  onToggleFullscreen,
  showPipToggle = false,
  pipHidden = false,
  onTogglePipHidden,
}) {
  const view360Label = viewModeFlat
    ? "Switch to 360° view"
    : "Switch to flat view";
  const fsLabel = isFullscreen ? "Exit fullscreen" : "Enter fullscreen";

  return (
    <div
      className="patrol-live-preview-toolbar ds-preview-controls"
      role="toolbar"
      aria-label="Live preview controls"
    >
      {showView360Toggle ? (
        <button
          type="button"
          className="ds-btn ds-btn--icon ds-btn--secondary"
          onClick={onToggleView360}
          title={view360Label}
          aria-label={view360Label}
        >
          {viewModeFlat ? <PatrolIcon360 /> : <PatrolIconFlat />}
        </button>
      ) : null}

      {showStreamTransportToggle ? (
        <button
          type="button"
          className="ds-btn ds-btn--secondary patrol-live-preview-toolbar__transport"
          onClick={onToggleStreamTransport}
          title={`Switch ${mainStreamKind} transport (current: ${activeStreamTransport.toUpperCase()})`}
          aria-label={`Switch ${mainStreamKind} transport (current: ${activeStreamTransport.toUpperCase()})`}
        >
          {activeStreamTransport === "hls" ? "HLS" : "WebRTC"}
        </button>
      ) : null}

      {showLensSwap ? (
        <button
          type="button"
          className="ds-btn ds-btn--icon ds-btn--primary"
          onClick={onToggleLens}
          title="Switch camera"
          aria-label="Switch camera"
        >
          <PatrolIconSwitchCamera />
        </button>
      ) : null}

      {showFullscreen ? (
        <button
          type="button"
          className="ds-btn ds-btn--icon ds-btn--ghost patrol-live-preview-toolbar__fs"
          onClick={onToggleFullscreen}
          title={fsLabel}
          aria-label={fsLabel}
        >
          {isFullscreen ? <PatrolIconExitFullscreen /> : <PatrolIconFullscreen />}
        </button>
      ) : null}

      {showPipToggle ? (
        <button
          type="button"
          className="ds-btn ds-btn--icon ds-btn--secondary"
          onClick={onTogglePipHidden}
          title={
            pipHidden
              ? "Show small preview (picture-in-picture)"
              : "Hide small preview (picture-in-picture)"
          }
          aria-label={
            pipHidden
              ? "Show small preview picture in picture"
              : "Hide small preview picture in picture"
          }
          aria-pressed={pipHidden}
        >
          {pipHidden ? <PatrolIconPipPopupHidden /> : <PatrolIconPipPopupVisible />}
        </button>
      ) : null}
    </div>
  );
}
